import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionModalCloseAll } from "../../../modals/actionModal";
import { actionViewportCenterOn } from "../../../viewport/actionViewport";
import { TypeActionBuildings } from "../actionBuildings";
export var epicBuildingsStartUnstoreBuilding = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.StartUnstoreBuilding), switchMap(function (action) {
        return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
            var origin = utilBuildings.getCenterPositionOnScreen(action.building, viewport);
            return from([actionModalCloseAll(), actionViewportCenterOn(origin)]);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsStartUnstoreBuilding.ts
// module id = 2088
// module chunks = 3